module.exports = __webpack_public_path__ + "img/Logo_iNoe_144px.528a5a6d.png";